<mat-card>
  <mat-card-content class="p-0">
    <app-datatable
      [configurationInput]="datatableConfigurations"
      [rowData]="datatableRows()"
      [columns]="datatableColumns"
      [total]="this.store.dataTotal$()"
      [customColumnDef]="[
        { name: 'name', template: nameCell, isSortable: true },
        { name: 'view', template: viewCell, isSortable: false },
      ]"
      (deleteClick)="initializeDelete()"
      (editClick)="initializeEdit()"
      (addClick)="initializeAdd()"
      (dataRefreshRequest)="datatableParams$.next($event)"
      (selectedItemsChange)="selectedDatatableItems.set($event)"
    />
  </mat-card-content>
</mat-card>

<ng-template #nameCell let-row="row">
  {{ row.name === defaultWorkflowName ? ('field.defaultWorkflow' | translate) : row.name }}
  <mat-chip *ngIf="row.name === defaultWorkflowName"> {{ 'system.label.default' | translate | uppercase }}</mat-chip>
</ng-template>

<ng-template #viewCell let-row="row">
  <button mat-stroked-button type="button" (click)="openDiagram(row)">
    <mat-icon>alt_route</mat-icon>
    {{ 'button.viewWorkflow' | translate }}
  </button>
</ng-template>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()" #form="ngForm">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-12 mb-3">
          <span class="dialog-section"
            ><mat-icon>description</mat-icon> {{ 'system.dialogSection.generalInformation' | translate }}</span
          >
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.get('name')"></mat-error>
        </mat-form-field>
        <mat-dropdown
          class="col-12"
          [options]="startStepOptions()"
          [configurationInput]="{
            singleSelection: true,
            hasMatError: true,
            text: 'field.startStep' | translate,
            repositionDropdownList: true,
          }"
          [formControl]="addEditForm.controls.startWorkflowStepId"
          [isFormSubmitted]="form.submitted"
        ></mat-dropdown>
      </div>

      <div class="row">
        <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
          <span class="dialog-section"><mat-icon>alt_route</mat-icon> {{ 'field.transitions' | translate }}</span>
          <button mat-button type="button" (click)="addTransitionRow()">
            <mat-icon>add</mat-icon>
            {{ 'field.addTransition' | translate }}
          </button>
        </div>

        <div
          class="col-12 d-flex align-items-start gap-2 mb-2"
          *ngFor="let row of transitions.controls; let i = index"
          [formGroup]="row"
        >
          <mat-dropdown
            class="flex-grow-1"
            [options]="stepOptions()"
            [configurationInput]="{
              singleSelection: true,
              hasMatError: true,
              text: 'field.sourceStep' | translate,
              repositionDropdownList: true,
            }"
            [formControl]="row.controls.workflowStepId"
            [isFormSubmitted]="form.submitted"
          ></mat-dropdown>

          <mat-dropdown
            class="flex-grow-1"
            [options]="stepOptions()"
            [configurationInput]="{
              singleSelection: true,
              hasMatError: true,
              text: 'field.nextStep' | translate,
              repositionDropdownList: true,
            }"
            [formControl]="row.controls.nextWorkflowStepId"
            [isFormSubmitted]="form.submitted"
          ></mat-dropdown>

          <button
            mat-mini-fab
            type="button"
            class="wf-transition-remove"
            [disabled]="transitions.length <= 1"
            (click)="removeTransitionRow(i)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <div class="col-12">
          <app-callout
            [variant]="chainVariant()"
            [icon]="chainIcon()"
            [title]="'workflowChain.title' | translate"
            [description]="'workflowChain.state.' + chainState() | translate"
          >
            <div class="wf-chain-issues" *ngIf="chainIssues().length">
              <app-callout
                *ngFor="let issue of chainIssues()"
                [dense]="true"
                [variant]="issue.variant"
                [icon]="issue.icon"
                [description]="issue.messageKey | translate: issue.params"
              ></app-callout>
            </div>
          </app-callout>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
